import React from "react";

var ExpandIcon = function ExpandIcon(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M7.914 0H0v7.914c0 .966 1.168 1.449 1.85.766l6.83-6.83c.683-.682.2-1.85-.766-1.85zm8.172 0c-.966 0-1.449 1.168-.766 1.85l6.83 6.83c.682.683 1.85.2 1.85-.766V0zm6.064 15.32l-6.83 6.83c-.683.682-.2 1.85.766 1.85H24v-7.914c0-.966-1.168-1.449-1.85-.766zm-20.3 0c-.682-.683-1.85-.2-1.85.766V24h7.914c.966 0 1.449-1.168.766-1.85z"
  }));
};

ExpandIcon.defaultProps = {
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};
ExpandIcon.defaultProps.solid = true;
export default ExpandIcon;